import { useCallback } from "react"

import { useNavigate, useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useNavigateWithSearchParams, useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { RoadsideSidebarComponents } from "../../components/RoadsideSidebarComponents"
import { ROADSIDE_CONDITION_URL_PARAM, ROADSIDE_TYPE_URL_PARAM } from "../../constants/urlParams"
import { useRoadsideStateContext } from "../../contexts/RoadsideContext"
import { useGetRoadsideTypeCatalogUtils } from "../../hooks/utils/useGetRoadsideTypeCatalogUtils"

import * as Styled from "./RoadsideMobileContent.styled"

export const RoadsideMobileContent = () => {
    const { getRoadsideTypeDepth, getRoadsideTypeChildren } = useGetRoadsideTypeCatalogUtils()
    const navigateWithSearchParams = useNavigateWithSearchParams()
    const navigate = useNavigate()

    const { getParam, getParams } = useUrlParams()
    const searchParams = getParams()
    const { ascendantCodes, filters } = useRoadsideStateContext()
    const { t } = useTranslation(I18N_NAMESPACE)
    const { code, road } = useParams()

    const handleChangeFilter = useCallback((filters) => {
        const filterCodeDepth = getRoadsideTypeDepth(filters.type)
        const children = getRoadsideTypeChildren(filters.type)
        if (filterCodeDepth % 2 === 1 && children.length > 1) {
            const condition = getParam(ROADSIDE_CONDITION_URL_PARAM)
            navigateWithSearchParams(`./code/${filters.type}?${ROADSIDE_TYPE_URL_PARAM}=${filters.type}${condition ? `&${ROADSIDE_CONDITION_URL_PARAM}=${condition}` : ""}`)
        }
    }, [getParam, getRoadsideTypeDepth, getRoadsideTypeChildren, navigateWithSearchParams])

    const navigateBack = useCallback(() => {
        const filterCodeDepth = getRoadsideTypeDepth(filters.type)

        if (code && filterCodeDepth % 2 === 0) {
            searchParams.set(ROADSIDE_TYPE_URL_PARAM, ascendantCodes[1])
            const newParams = Array.from(searchParams.entries()).reduce((acc, [key, value]) => {
                return `${acc}${key}=${value}&`
            }, "?")
                .slice(0, -1)
            navigate(road ? `../${road}${newParams}` : `../${newParams}`)
        } else {
            navigateWithSearchParams("../")
        }
    }, [ascendantCodes, code, getRoadsideTypeDepth, navigate, navigateWithSearchParams, searchParams, road, filters.type])

    return (
        <Styled.BottomSheetContent
            id="roadside-sidebar"
            onBack={(road || code) ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.roadsideSidebar.${road ? "roadTitle" : "title"}`)}
        >
            <Styled.Container>
                <RoadsideSidebarComponents handleChangeTypeFilter={handleChangeFilter} />
            </Styled.Container>
        </Styled.BottomSheetContent>
    )
}